<eo-dropdown
  [id]="id"
  [config]="getConfig()"
  [label]="getLabel()"
  [help]="getHelp()"
  [errors]="getErrors()"
  [tabindex]="getTabIndex()"
  [options]="(httpData$ | async) ?? []"
  [optionLabel]="getOptionLabel()"
  [optionValue]="getOptionValue()"
  [placeholder]="getPlaceholder()"
  [showClear]="getShowClear()"
  [filter]="filter"
  [filterBy]="getFilterBy()"
  [filterFields]="getFilterFields()"
  [filterPlaceholder]="getFilterPlaceholder()"
  [loading]="loading"
  [inputStyleClass]="getInputStyleClass()"
  [appendTo]="getAppendTo()"
  (onRemove)="onRemoveHandler()"
  (onChange)="onChangeHandler($event)"
  (onBlur)="onBlurHandler($event)"
  (onFocus)="onFocusHandler($event)"
/>
